import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grow h-full flex flex-col justify-between relative" }
const _hoisted_2 = { class: "text-base text-cebai-base-dark mb-4" }
const _hoisted_3 = { class: "flex flex-wrap mb-4" }
const _hoisted_4 = { class: "mt-auto flex items-center justify-between" }
const _hoisted_5 = { class: "flex items-center -ml-1" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg ml-1.5" }, "0", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_9 = { class: "text-lg ml-1.5" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "ml-5"
}
const _hoisted_12 = {
  key: 1,
  class: "w-8 h-8 scale-50 -mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BulbIcon = _resolveComponent("BulbIcon")!
  const _component_BulbFilledIcon = _resolveComponent("BulbFilledIcon")!
  const _component_PlanIcon = _resolveComponent("PlanIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: {
        name: _ctx.challengeLink,
        params: { id: _ctx.challenge._id },
      },
      class: "group relative overflow-hidden flex flex-col h-full p-6 rounded-2xl border-[3px] border-cebai-grey-lighter bg-cebai-base-light hover:bg-cebai-grey-lighter transition"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.showExpandTitleButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-cebai-primary",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleTitle && _ctx.toggleTitle(...args)), ["prevent"]))
              }, [
                (_ctx.isTitleExpanded)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" See less ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" See more ")
                    ], 64))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjects, (subject) => {
            return (_openBlock(), _createElementBlock("p", {
              key: subject,
              class: "mr-2 mb-2 text-base py-1 px-2 rounded-md border-2 border-cebai-grey-light group-hover:border-cebai-base-light"
            }, _toDisplayString(_ctx.capitaliseFirstLetter(subject)), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.challenge.ideas.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_BulbIcon, { class: "fill-current" }),
                  _hoisted_7
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_BulbFilledIcon, { class: "fill-current" }),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.challenge.ideas.length), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.challenge.solutions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_PlanIcon, { class: "stroke-current" })
                ]))
              : _createCommentVNode("", true),
            (_ctx.icon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { class: "fill-current" }))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}